import { preChat } from './preChat';

const pt = {
  ...preChat,
};

export default pt;
